<template>
    <div class="content">
        <router-view></router-view>
        <tabbar :routers="tabbar"></tabbar>
    </div>
</template>

<script>
    import Tabbar from "../components/Tabbar";

    export default {
        name: "Index",
        components: {Tabbar},

        data() {
            return {
                tabbar:[
                    {
                        path: '/home',
                        normal:require('./../assets/homeb.png'),
                        icon:require('./../assets/home.png'),
                        name: '主页'
                    },
                    // {
                    //     path: '/package/order',
                    //     normal:require('./../assets/subscribeb.png'),
                    //     icon:require('../assets/subscribe.png'),
                    //     name: '我的加价购'
                    // },
                    {
                        path: '/order',
                        normal:require('./../assets/orderb.png'),
                        icon:require('./../assets/order.png'),
                        name: '我的订单'
                    },
                    {
                        path: '/stampShop',
                        normal:require('./../assets/pointb.png'),
                        icon:require('./../assets/point.png'),
                        name: '印花商城'
                    },
                    {
                        path: '/mine',
                        normal:require('./../assets/personb.png'),
                        icon:require('./../assets/person.png'),
                        name: '个人中心'
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .content {
        background-color: #fdf9f7;
    }
</style>